<template>
	<div class="introduct">
		<div class="introduct-main">
			<div class="introduct-title">
				<ul>
					<li><span>{{$t('introduction.introductiontitle')}}</span></li>
				</ul>
			</div>
			<div class="introduct-content">
				<ul>
					<li>
						<span>{{$t('introduction.introduction01')}}</span>
					</li>
					<li>
						<span>{{$t('introduction.introduction02')}}</span>
					</li>
				</ul>
				<ol>
					<li>
						<span>{{$t('introduction.introduction03')}}</span>
					</li>
					<li>
						<span>{{$t('introduction.introduction04')}}</span>
					</li>
					<li>
						<span>{{$t('introduction.introduction05')}}</span>
					</li>
				</ol>
			</div>
			<div class="introduct-bottom"></div>
		</div>
		<div class="introduct-close" @click="introductclose"><img src="../../../static/img/turn_off.png" alt="" /></div>
	</div>
	
</template>

<script>
import axios from "axios";
import Qs from "qs";
export default{
	name:'introduction',
	data(){
		return{
			
		}
	},
	mounted(){
		
	},
	created(){
		
	},
	watch:{
		
	},
	methods: {
		introductclose(){
			this.$emit("introductC",true);
		}
	}
}
	
	
</script>

<style>
.introduct{
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	z-index: 9999;
	overflow: auto;
	background: rgba(0,0,0,.5);
}
.introduct-main{
	width: 90%;
	height: auto;
	position: relative;
	top: 10%;
	background: url(../../../static/img/introductbg.png) top center #fff no-repeat;
	background-size: 100% auto;
	border-radius: 3%;
	margin: 0 auto;
	overflow: hidden;
}
.introduct-title{
	width: 100%;
}
.introduct-title ul{
	width: 100%;
	padding:3rem 0 2rem 0;
	text-align: center;	
}
.introduct-title ul li span{
	font-size: 1.1rem;
	font-family: "PingFangSC-Regular";
}
.introduct-content{
	width: 94%;
	height: auto;
	margin: 0 auto;
}
.introduct-content ul li{
	text-align: left;
	line-height: 1.3rem;
	font-size: .8rem;
	font-family: "PingFangSC-Regular";
}
.introduct-content ol{
	width: 94%;
	margin-left: 6%;
}
.introduct-content ol li{
	text-align: left;
	line-height: 1.3rem;
	font-size: .8rem;
	font-family: "PingFangSC-Regular";
}
.introduct-bottom{
	width: 100%;
	height: 2rem;
	background-image: linear-gradient(to right , #9fe5f3, #7dc3f2);
	padding-top: 20px;
    margin-top: 20px;
    border-radius: 50% 50% 0 0;
}
.introduct-close{
	width: 10%;
	height: auto;
	margin: 0 auto;
	position: relative;
    top: 10%;
}
.introduct-close img{
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/m_page/login/introduction.vue